module.exports = __webpack_public_path__ + "static/img/8.e3f0c14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/yijia/8.png
// module id = XpZ+
// module chunks = 0